$(function(){

    /* append video in the right format - some browser such as Chrome does not support media query in source tag */
    const video = $('.BlockHero-video');

    // get desktop or mobile video depending on viewport width and prepend it to video tag
    const VideoSource = $(window).width() <= 1200 ? video.data('source-mobile') : video.data('source-desktop');
    video.prepend(`<source src='${VideoSource}' type='video/mp4'>`);



    /* height of video with notification block */
    function setNotificationVariable(){

        // get height of notification
        let $NotificationHeight = ($('.BlockNotification').height() || 0) + 'px';

        // set it as css variable
        $("html").attr("style", `--BlockNotificationHeight:${$NotificationHeight}`);
    }

    // update css variable when page is loaded
    setNotificationVariable();

    // and when page is resized
    $(window).on('resize', function(){
        setNotificationVariable();
    });


    /* mute / unmute video */
    $(".BlockHero-videoWrapper .VolumeSwitcher").on('click', function(){

        let $video = $('.BlockHero-video');

        if ( $video.prop('muted') )
        {
            $video.prop('muted', false);

            // data attribute for css icon change
            $video.attr('data-muted', false);
        }
        else 
        {
            $video.prop('muted', true);

            // data attribute for css icon change
            $video.attr('data-muted', true);
        }
    });
});